/* District Bangle — predictive-search.js
   Debounced predictive search via the Predictive Search API. The form is a real
   GET to /search, so search works fully with JavaScript disabled. */
import { BaseElement, define, money } from '@theme/global';

class PredictiveSearch extends BaseElement {
  init() {
    this.input = this.querySelector('[data-psearch-input]');
    this.results = this.querySelector('[data-psearch-results]');
    if (!this.input) return;
    this.listen(this.input, 'input', () => this.debounced());
  }
  debounced() { clearTimeout(this._t); this._t = setTimeout(() => this.search(), 250); }
  async search() {
    const q = this.input.value.trim();
    if (q.length < 2) { this.results.innerHTML = ''; return; }
    // The JSON Predictive Search API requires the `.json` endpoint; the bare
    // path 422s ("Missing section_id param"). routes.predictive_search_url is
    // "/search/suggest" (may be locale-prefixed) — append ".json".
    const base = (this.dataset.url || '/search/suggest').replace(/\.json$/, '');
    const url = `${base}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();
      this.render((data.resources && data.resources.results && data.resources.results.products) || []);
    } catch (_) { /* keep it graceful — form still submits */ }
  }
  render(products) {
    if (!products.length) { this.results.innerHTML = `<p class="psearch__empty">${window.theme.strings.noResults || 'No matches yet.'}</p>`; return; }
    this.results.innerHTML = products.map((p) => {
      const img = p.featured_image && p.featured_image.url ? `<div class="media media--tall"><img src="${p.featured_image.url}&width=120" alt="" loading="lazy"></div>` : '<div class="media media--tall media-placeholder"></div>';
      const price = p.price ? `<span class="text-muted">${money(p.price)}</span>` : '';
      return `<a class="psearch__item" href="${p.url}">${img}<span><span class="psearch__item-title">${p.title}</span><br>${price}</span></a>`;
    }).join('');
  }
}

define('predictive-search', PredictiveSearch);
document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('predictive-search').forEach((el) => { el._bound = false; el.connectedCallback(); });
});
